
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { contentActionCreators } from "../../actions/contentActionCreators";
import {
    Grid,
    Paper,
    withStyles,
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText
} from "@material-ui/core";
import { LinkContainer } from "react-router-bootstrap";
import { CalendarToday, LocationOn } from "@material-ui/icons";
import Moment from "react-moment";
import Submenu from "../Submenu";
import Team from "../content/Team";
import { menuActionCreators } from "../../actions/menuActionCreators";
import { Twitter } from "react-social-sharing";
import { Facebook } from "react-social-sharing";
import { Linkedin } from "react-social-sharing";
import MetaTags from 'react-meta-tags';
import striptags from 'striptags';
import { getLoggedUser } from "../../helpers";
import { withTranslation } from "react-i18next"; // Import withTranslation
import i18n from "i18next"; // Import i18n to access current language

const styles = theme => ({
    root: {
        flexGrow: 1
    },
    paper: {
        padding: theme.spacing.unit * 2,
        overflow: "hidden",
        textAlign: "justify"
    },
    coverImage: {
        width: "100%"
    },
    socialShare: {
        color: theme.palette.primary.main,
        "& span": {
            display: "none"
        }
    }
});

class Article extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    componentWillMount() {
        this.props.getArticle(this.props.match.params.id);
        this.props.requestSubmenuElements(this.props.match.params.id);
    }

    componentDidMount() {
        this.languageChangeHandler = () => {
            const { match, requestSubmenuElements } = this.props;
            requestSubmenuElements(match.params.id);
        };
        i18n.on('languageChanged', this.languageChangeHandler);
    }

    componentWillUnmount() {
        if (this.languageChangeHandler) {
            i18n.off('languageChanged', this.languageChangeHandler);
        }
    }


    componentWillReceiveProps(next) {
        if (next.match.params.id === this.props.match.params.id) return;
        this.props.getArticle(next.match.params.id);
        this.props.requestSubmenuElements(next.match.params.id);
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleDelete(articleId) {
        this.props.deleteArticle(articleId);
    }

    render() {
        const { t } = this.props; // Use t for translations
        const article = this.props.articleToRead;
        const description = striptags(i18n.language === "bg" ? article.title : article.titleEn).substring(0, 200);
        const { classes, menu } = this.props;
        const loggedUser = getLoggedUser();
        const adminSignedIn =
            loggedUser && loggedUser.token && loggedUser.userType === "admin"
                ? true
                : false;

        return (
            <div className={classes.root}>
                <MetaTags>
                    <title>
                        {i18n.language === "bg"
                            ? article.title || article.titleEn
                            : article.titleEn || article.title}
                    </title>
                    <meta name="description" content={description} />
                    <meta property="og:title" content=
                        {i18n.language === "bg"
                            ? article.title || article.titleEn
                            : article.titleEn || article.title}
                    />
                    {article.coverImg && <meta property="og:image" content={article.coverImg} />}
                </MetaTags>

                <Grid container spacing={24}>
                    <Grid item xs={12} sm={3}>
                        {menu.submenuElements !== undefined &&
                            menu.submenuElements.length > 0 ? (
                            <Submenu elements={menu.submenuElements} />
                        ) :
                            (
                                <Paper className={classes.paper}>
                                    <h4>
                                        {t('publishedOn')}{" "}
                                        <Moment format="DD.MM.YYYY HH:mm" withTitle>
                                            {article.createdOn}
                                        </Moment>
                                    </h4>
                                    <div className={classes.socialShare}>
                                        <Twitter
                                            link={`https://iccd.unwe.bg/article/${article.id}`}
                                        />
                                        <Facebook
                                            link={`https://iccd.unwe.bg/article/${article.id}`}
                                        />
                                        <Linkedin
                                            link={`https://iccd.unwe.bg/article/${article.id}`}
                                        />
                                    </div>
                                </Paper>
                            )}
                        {adminSignedIn ? (
                            <div>
                                <LinkContainer
                                    style={{ marginTop: 15 }}
                                    to={`/article/edit/${article.id}`}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary">
                                        {t('edit')} {/* Translated button text */}
                                    </Button>
                                </LinkContainer>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    style={{ marginTop: 15 }}
                                    onClick={this.handleClickOpen}>
                                    {t('delete')} {/* Translated button text */}
                                </Button>
                                <Dialog
                                    open={this.state.open}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description">
                                    <DialogTitle id="alert-dialog-title">
                                        {t('deleteArticle')} {/* Translated dialog title */}
                                    </DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            {t('confirmDeleteArticle')} {/* Translated dialog content */}
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button
                                            onClick={this.handleClose}
                                            variant="contained"
                                            color="default">
                                            {t('cancel')} {/* Translated button text */}
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() =>
                                                this.handleDelete(article.id)
                                            }>
                                            {t('deleteConfirmation')} {/* Translated button text */}
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </div>
                        ) : null}
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={
                            menu.submenuElements !== undefined &&
                                menu.submenuElements.length > 0
                                ? 8
                                : 6
                        }>
                        <Paper className={classes.paper}>
                            {article.component == undefined && (
                                <div>
                                    <h2>
                                        {i18n.language === "bg"
                                            ? article.title || article.titleEn
                                            : article.titleEn || article.title}
                                    </h2>
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: i18n.language === "bg"
                                                ? article.content || article.contentEn
                                                : article.contentEn || article.content
                                        }}
                                    />
                                </div>
                            )}
                            {article.component !== undefined &&
                                displayInnerComponent(article.component)}
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        {menu.submenuElements !== undefined &&
                            menu.submenuElements.length > 0 ? (
                            <Typography />
                        ) : (
                            <Paper className={classes.paper}>
                                {article.eventDate != undefined && (
                                    <h3>
                                        <CalendarToday />{" "}
                                        <Moment format="DD.MM.YYYY" withTitle>
                                            {article.eventDate}
                                        </Moment>
                                        {article.eventDateEnd &&
                                            <Moment format=" - DD.MM.YYYY" withTitle>
                                                {article.eventDateEnd}
                                            </Moment>
                                        }
                                    </h3>
                                )}
                                {article.eventLocation != undefined && (
                                    <h3>
                                        <LocationOn />
                                        {i18n.language === "bg"
                                            ? article.eventLocation || article.eventLocationEn
                                            : article.eventLocationEn || article.eventLocation}
                                    </h3>
                                )}
                                {article.coverImg != undefined && (
                                    <img
                                        src={article.coverImg}
                                        alt={i18n.language === "bg"
                                            ? article.title || article.titleEn
                                            : article.titleEn || article.title}
                                        className={classes.coverImage}
                                    />
                                )}
                            </Paper>
                        )}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

function displayInnerComponent(component) {
    const components = {
        Team: <Team />
    };
    return components[component];
}

// Wrap the component with withTranslation HOC
export default withTranslation()(
    withStyles(styles)(
        connect(
            state => {
                return {
                    ...state.content,
                    menu: state.menu
                };
            },
            dispatch =>
                bindActionCreators(
                    { ...contentActionCreators, ...menuActionCreators },
                    dispatch
                )
        )(Article)
    )
);




//import React, { Component } from "react";
//import { connect } from "react-redux";
//import { bindActionCreators } from "redux";
//import { contentActionCreators } from "../../actions/contentActionCreators";
//import {
//    Grid,
//    Paper,
//    withStyles,
//    Typography,
//    Button,
//    Dialog,
//    DialogTitle,
//    DialogContent,
//    DialogActions,
//    DialogContentText
//} from "@material-ui/core";
//import { LinkContainer } from "react-router-bootstrap";
//import { CalendarToday, LocationOn } from "@material-ui/icons";
//import Moment from "react-moment";
//import Submenu from "../Submenu";
//import Team from "../content/Team";
//import { menuActionCreators } from "../../actions/menuActionCreators";
//import { Twitter } from "react-social-sharing";
//import { Facebook } from "react-social-sharing";
//import { Linkedin } from "react-social-sharing";
//import MetaTags from 'react-meta-tags';
//import striptags from 'striptags';
//import { getLoggedUser } from "../../helpers";
//import { withTranslation } from "react-i18next"; // Import withTranslation
//import i18n from "i18next"; // Import i18n to access current language

//const styles = theme => ({
//    root: {
//        flexGrow: 1
//    },
//    paper: {
//        padding: theme.spacing.unit * 2,
//        overflow: "hidden",
//        textAlign: "justify"
//    },
//    coverImage: {
//        width: "100%"
//    },
//    socialShare: {
//        color: theme.palette.primary.main,
//        "& span": {
//            display: "none"
//        }
//    }
//});

//class Article extends Component {
//    constructor(props) {
//        super(props);
//        this.state = {
//            open: false
//        };
//    }

//    componentWillMount() {
//        this.props.getArticle(this.props.match.params.id);
//        this.props.requestSubmenuElements(this.props.match.params.id);
//    }

//    componentDidMount() {
//        this.languageChangeHandler = () => {
//            const { match, requestSubmenuElements } = this.props;
//            requestSubmenuElements(match.params.id);
//        };
//        /*i18n.on('languageChanged', this.languageChangeHandler);*/

//        const { currentLanguage } = useSelector(state => state.language);
//        const dispatch = useDispatch();

//        useEffect(() => {
//            if (articleId) {
//                dispatch(menuActionCreators.requestSubmenuElements(articleId));
//            }
//        }, [articleId, currentLanguage, dispatch]);

//    }

//    componentWillUnmount() {
//        if (this.languageChangeHandler) {
//            i18n.off('languageChanged', this.languageChangeHandler);
//        }
//    }


//    componentWillReceiveProps(next) {
//        if (next.match.params.id === this.props.match.params.id) return;
//        this.props.getArticle(next.match.params.id);
//        this.props.requestSubmenuElements(next.match.params.id);
//    }

//    handleClickOpen = () => {
//        this.setState({ open: true });
//    };

//    handleClose = () => {
//        this.setState({ open: false });
//    };

//    handleDelete(articleId) {
//        this.props.deleteArticle(articleId);
//    }

//    render() {
//        const { t } = this.props; // Use t for translations
//        const article = this.props.articleToRead;
//        const description = striptags(i18n.language === "bg" ? article.title : article.titleEn).substring(0, 200);
//        const { classes, menu } = this.props;
//        const loggedUser = getLoggedUser();
//        const adminSignedIn =
//            loggedUser && loggedUser.token && loggedUser.userType === "admin"
//                ? true
//                : false;

//        return (
//            <div className={classes.root}>
//                <MetaTags>
//                    <title>
//                        {i18n.language === "bg"
//                            ? article.title || article.titleEn
//                            : article.titleEn || article.title}
//                    </title>
//                    <meta name="description" content={description} />
//                    <meta property="og:title" content=
//                        {i18n.language === "bg"
//                            ? article.title || article.titleEn
//                            : article.titleEn || article.title}
//                    />
//                    {article.coverImg && <meta property="og:image" content={article.coverImg} />}
//                </MetaTags>

//                <Grid container spacing={24}>
//                    <Grid item xs={12} sm={3}>
//                        {menu.submenuElements !== undefined &&
//                            menu.submenuElements.length > 0 ? (
//                            <Submenu elements={menu.submenuElements} />
//                        ) :
//                            (
//                            <Paper className={classes.paper}>
//                                <h4>
//                                    {t('publishedOn')}{" "}
//                                    <Moment format="DD.MM.YYYY HH:mm" withTitle>
//                                        {article.createdOn}
//                                    </Moment>
//                                </h4>
//                                <div className={classes.socialShare}>
//                                    <Twitter
//                                        link={`https://iccd.unwe.bg/article/${article.id}`}
//                                    />
//                                    <Facebook
//                                        link={`https://iccd.unwe.bg/article/${article.id}`}
//                                    />
//                                    <Linkedin
//                                        link={`https://iccd.unwe.bg/article/${article.id}`}
//                                    />
//                                </div>
//                            </Paper>
//                        )}
//                        {adminSignedIn ? (
//                            <div>
//                                <LinkContainer
//                                    style={{ marginTop: 15 }}
//                                    to={`/article/edit/${article.id}`}>
//                                    <Button
//                                        fullWidth
//                                        variant="contained"
//                                        color="primary">
//                                        {t('edit')} {/* Translated button text */}
//                                    </Button>
//                                </LinkContainer>
//                                <Button
//                                    fullWidth
//                                    variant="contained"
//                                    color="primary"
//                                    style={{ marginTop: 15 }}
//                                    onClick={this.handleClickOpen}>
//                                    {t('delete')} {/* Translated button text */}
//                                </Button>
//                                <Dialog
//                                    open={this.state.open}
//                                    onClose={this.handleClose}
//                                    aria-labelledby="alert-dialog-title"
//                                    aria-describedby="alert-dialog-description">
//                                    <DialogTitle id="alert-dialog-title">
//                                        {t('deleteArticle')} {/* Translated dialog title */}
//                                    </DialogTitle>
//                                    <DialogContent>
//                                        <DialogContentText id="alert-dialog-description">
//                                            {t('confirmDeleteArticle')} {/* Translated dialog content */}
//                                        </DialogContentText>
//                                    </DialogContent>
//                                    <DialogActions>
//                                        <Button
//                                            onClick={this.handleClose}
//                                            variant="contained"
//                                            color="default">
//                                            {t('cancel')} {/* Translated button text */}
//                                        </Button>
//                                        <Button
//                                            variant="contained"
//                                            color="primary"
//                                            onClick={() =>
//                                                this.handleDelete(article.id)
//                                            }>
//                                            {t('deleteConfirmation')} {/* Translated button text */}
//                                        </Button>
//                                    </DialogActions>
//                                </Dialog>
//                            </div>
//                        ) : null}
//                    </Grid>
//                    <Grid
//                        item
//                        xs={12}
//                        sm={
//                            menu.submenuElements !== undefined &&
//                                menu.submenuElements.length > 0
//                                ? 8
//                                : 6
//                        }>
//                        <Paper className={classes.paper}>
//                            {article.component == undefined && (
//                                <div>
//                                    <h2>
//                                        {i18n.language === "bg"
//                                            ? article.title || article.titleEn
//                                            : article.titleEn || article.title}
//                                    </h2>
//                                    <p
//                                        dangerouslySetInnerHTML={{
//                                            __html: i18n.language === "bg"
//                                                ? article.content || article.contentEn
//                                                : article.contentEn || article.content
//                                        }}
//                                    />
//                                </div>
//                            )}
//                            {article.component !== undefined &&
//                                displayInnerComponent(article.component)}
//                        </Paper>
//                    </Grid>
//                    <Grid item xs={12} sm={3}>
//                        {menu.submenuElements !== undefined &&
//                            menu.submenuElements.length > 0 ? (
//                            <Typography />
//                        ) : (
//                            <Paper className={classes.paper}>
//                                {article.eventDate != undefined && (
//                                    <h3>
//                                        <CalendarToday />{" "}
//                                        <Moment format="DD.MM.YYYY" withTitle>
//                                            {article.eventDate}
//                                        </Moment>
//                                        {article.eventDateEnd &&
//                                            <Moment format=" - DD.MM.YYYY" withTitle>
//                                                {article.eventDateEnd}
//                                            </Moment>
//                                        }
//                                    </h3>
//                                )}
//                                {article.eventLocation != undefined && (
//                                    <h3>
//                                            <LocationOn />
//                                            {i18n.language === "bg"
//                                                ? article.eventLocation || article.eventLocationEn
//                                                : article.eventLocationEn || article.eventLocation}                                            
//                                    </h3>
//                                )}
//                                {article.coverImg != undefined && (
//                                    <img
//                                        src={article.coverImg}
//                                            alt={i18n.language === "bg"
//                                                ? article.title || article.titleEn
//                                                : article.titleEn || article.title}
//                                        className={classes.coverImage}
//                                    />
//                                )}
//                            </Paper>
//                        )}
//                    </Grid>
//                </Grid>
//            </div>
//        );
//    }
//}

//function displayInnerComponent(component) {
//    const components = {
//        Team: <Team />
//    };
//    return components[component];
//}

//// Wrap the component with withTranslation HOC
//export default withTranslation()(
//    withStyles(styles)(
//        connect(
//            state => {
//                return {
//                    ...state.content,
//                    menu: state.menu
//                };
//            },
//            dispatch =>
//                bindActionCreators(
//                    { ...contentActionCreators, ...menuActionCreators },
//                    dispatch
//                )
//        )(Article)
//    )
//);



//import React, { Component } from "react";
//import { connect } from "react-redux";
//import { bindActionCreators } from "redux";
//import { contentActionCreators } from "../../actions/contentActionCreators";
//import {
//    Grid,
//    Paper,
//    withStyles,
//    Typography,
//    Button,
//    Dialog,
//    DialogTitle,
//    DialogContent,
//    DialogActions,
//    DialogContentText
//} from "@material-ui/core";
//import { LinkContainer } from "react-router-bootstrap";
//import { CalendarToday, LocationOn } from "@material-ui/icons";
//import Moment from "react-moment";
//import Submenu from "../Submenu";
//import Team from "../content/Team";
//import { menuActionCreators } from "../../actions/menuActionCreators";
//import { Twitter } from "react-social-sharing";
//import { Facebook } from "react-social-sharing";
//import { Linkedin } from "react-social-sharing";
//import MetaTags from 'react-meta-tags';
//import striptags from 'striptags';
//import { getLoggedUser } from "../../helpers";

//const styles = theme => ({
//    root: {
//        flexGrow: 1
//    },
//    paper: {
//        padding: theme.spacing.unit * 2,
//        overflow: "hidden",
//        textAlign: "justify"
//    },
//    coverImage: {
//        width: "100%"
//    },
//    socialShare: {
//        color: theme.palette.primary.main,
//        "& span": {
//            display: "none"
//        }
//    }
//});

//class Article extends Component {
//    constructor(props) {
//        super(props);
//        this.state = {
//            open: false
//        };
//    }

//    componentWillMount() {
//        this.props.getArticle(this.props.match.params.id);
//        this.props.requestSubmenuElements(this.props.match.params.id);
//    }

//    componentWillReceiveProps(next) {
//        if (next.match.params.id === this.props.match.params.id) return;
//        this.props.getArticle(next.match.params.id);
//        this.props.requestSubmenuElements(next.match.params.id);
//    }

//    handleClickOpen = () => {
//        this.setState({ open: true });
//    };

//    handleClose = () => {
//        this.setState({ open: false });
//    };

//    handleDelete(articleId) {
//        this.props.deleteArticle(articleId);
//    }

//    render() {
//        const article = this.props.articleToRead;
//        const description = striptags(article.content).substring(0, 200);
//        const { classes, menu } = this.props;
//        const loggedUser = getLoggedUser();
//        const adminSignedIn =
//            loggedUser && loggedUser.token && loggedUser.userType === "admin"
//                ? true
//                : false;

//        return (
//            <div className={classes.root}>
//                <MetaTags>
//                    <title>{article.title}</title>
//                    <meta name="description" content={description} />
//                    <meta property="og:title" content={article.title} />
//                    {article.coverImg && <meta property="og:image" content={article.coverImg} />}
//                </MetaTags>

//                <Grid container spacing={24}>
//                    <Grid item xs={12} sm={3}>
//                        {menu.submenuElements !== undefined &&
//                            menu.submenuElements.length > 0 ? (
//                                <Submenu elements={menu.submenuElements} />
//                            ) : (
//                                <Paper className={classes.paper}>
//                                    <h4>
//                                        Публикувано на{" "}
//                                        <Moment format="DD.MM.YYYY HH:mm" withTitle>
//                                            {article.createdOn}

//                                        </Moment>
//                                    </h4>
//                                    <div className={classes.socialShare}>
//                                        <Twitter
//                                            link={`https://iccd.unwe.bg/article/${
//                                                article.id
//                                                }`}
//                                        />
//                                        <Facebook
//                                            link={`https://iccd.unwe.bg/article/${
//                                                article.id
//                                                }`}
//                                        />
//                                        <Linkedin
//                                            link={`https://iccd.unwe.bg/article/${
//                                                article.id
//                                                }`}
//                                        />
//                                    </div>
//                                </Paper>
//                            )}
//                        {adminSignedIn ? (
//                            <div>
//                                <LinkContainer
//                                    style={{ marginTop: 15 }}
//                                    to={`/article/edit/${article.id}`}>
//                                    <Button
//                                        fullWidth
//                                        variant="contained"
//                                        color="primary">
//                                        Редактиране
//									</Button>
//                                </LinkContainer>
//                                <Button
//                                    fullWidth
//                                    variant="contained"
//                                    color="primary"
//                                    style={{ marginTop: 15 }}
//                                    onClick={this.handleClickOpen}>
//                                    Изтриване
//								</Button>
//                                <Dialog
//                                    open={this.state.open}
//                                    onClose={this.handleClose}
//                                    aria-labelledby="alert-dialog-title"
//                                    aria-describedby="alert-dialog-description">
//                                    <DialogTitle id="alert-dialog-title">
//                                        {"Изтриване на статия"}
//                                    </DialogTitle>
//                                    <DialogContent>
//                                        <DialogContentText id="alert-dialog-description">
//                                            Сигурни ли сте, че искате да
//											изтриете тази статия?
//										</DialogContentText>
//                                    </DialogContent>
//                                    <DialogActions>
//                                        <Button
//                                            onClick={this.handleClose}
//                                            variant="contained"
//                                            color="default">
//                                            Отказ
//										</Button>
//                                        <Button
//                                            variant="contained"
//                                            color="primary"
//                                            onClick={() =>
//                                                this.handleDelete(article.id)
//                                            }>
//                                            Изтриване
//										</Button>
//                                    </DialogActions>
//                                </Dialog>
//                            </div>
//                        ) : null}
//                    </Grid>
//                    <Grid
//                        item
//                        xs={12}
//                        sm={
//                            menu.submenuElements !== undefined &&
//                                menu.submenuElements.length > 0
//                                ? 8
//                                : 6
//                        }>
//                        <Paper className={classes.paper}>
//                            {article.component == undefined && (
//                                <div>
//                                    <h2>{article.title}</h2>
//                                    <p
//                                        dangerouslySetInnerHTML={{
//                                            __html: article.content
//                                        }}
//                                    />
//                                </div>
//                            )}
//                            {article.component !== undefined &&
//                                displayInnerComponent(article.component)}
//                        </Paper>
//                    </Grid>
//                    <Grid item xs={12} sm={3}>
//                        {menu.submenuElements !== undefined &&
//                            menu.submenuElements.length > 0 ? (
//                                <Typography />
//                            ) : (
//                                <Paper className={classes.paper}>
//                                    {article.eventDate != undefined && (
//                                        <h3>
//                                            <CalendarToday />{" "}
//                                            <Moment format="DD.MM.YYYY" withTitle>
//                                                {article.eventDate}
//                                            </Moment>
//                                            {article.eventDateEnd && 
//                                                <Moment format=" - DD.MM.YYYY" withTitle>
//                                                     {article.eventDateEnd}
//                                                </Moment>
//                                            }
//                                        </h3>
//                                    )}
//                                    {article.eventLocation != undefined && (
//                                        <h3>
//                                            <LocationOn /> {article.eventLocation}
//                                        </h3>
//                                    )}
//                                    {article.coverImg != undefined && (
//                                        <img
//                                            src={article.coverImg}
//                                            alt={article.title}
//                                            className={classes.coverImage}
//                                        />
//                                    )}
//                                </Paper>
//                            )}
//                    </Grid>
//                </Grid>
//            </div>
//        );
//    }
//}

//function displayInnerComponent(component) {
//    const components = {
//        Team: <Team />
//    };
//    return components[component];
//}

//export default withStyles(styles)(
//    connect(
//        state => {
//            return {
//                ...state.content,
//                menu: state.menu
//            };
//        },
//        dispatch =>
//            bindActionCreators(
//                { ...contentActionCreators, ...menuActionCreators },
//                dispatch
//            )
//    )(Article)
//);
